// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dr-b";
export var colorBlue = "_dr-8";
export var colorDot = "_dr-0";
export var colorDotLarge = "_dr-2";
export var colorDotSmall = "_dr-1";
export var colorGreen = "_dr-7";
export var colorGrey = "_dr-3";
export var colorOrange = "_dr-5";
export var colorPink = "_dr-a";
export var colorPurple = "_dr-9";
export var colorRed = "_dr-4";
export var colorYellow = "_dr-6";